export const listUpgradeBenefits = [
  'Additional information like appointments, questions, vaccinations, and more',
  'Attach documents and photos to your info and notes',
  'Share custom access links with anyone',
];